exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".BlockLoading-df067c94{display:flex;flex-direction:column;align-items:center;justify-content:center;background:#ebebeb;font-family:\"aktiv-grotesk\",\"Aktiv Grotesk\",\"Open Sans\",\"Gill Sans MT\",\"Gill Sans\",Corbel,Arial,sans-serif;font-size:14px}\n", ""]);

// Exports
exports.locals = {
	"BlockLoading": "BlockLoading-df067c94"
};